import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/sales-tracker/my-trackings",
  topStores: "/sales-tracker/top-stores",
  topProducts: "/sales-tracker/top-products",
};
